var render = function render(){var _vm=this,_c=_vm._self._c;return _c('errorContainer',{attrs:{"error":_vm.erreur,"warning":_vm.warning}},[_c('transition',{attrs:{"name":"slide"}},[_c('b-card',{staticClass:"mt-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('per-assignee')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }